import { Grid } from 'antd';

const { useBreakpoint } = Grid;

export type Breakpoint = 'xxl' | 'xl' | 'lg' | 'md' | 'sm' | 'xs';
export const responsiveArray: Breakpoint[] = [
  'xxl',
  'xl',
  'lg',
  'md',
  'sm',
  'xs',
];

export type UseValueBreakpointConfigs<T> = Partial<Record<Breakpoint, T>>;

export const useValueBreakpoint = <T,>(
  configs: UseValueBreakpointConfigs<T>,
): { config: T | undefined } => {
  const curConfigs = { ...configs };
  const screenMap = useBreakpoint();

  for (const screen of responsiveArray) {
    const isMatch = screenMap[screen];

    if (isMatch && Object.prototype.hasOwnProperty.call(curConfigs, screen)) {
      return { config: curConfigs[screen] };
    } else if (
      isMatch &&
      !Object.prototype.hasOwnProperty.call(curConfigs, screen)
    ) {
      return { config: undefined };
    }
  }

  // return default value
  return { config: undefined };
};
